module.exports = __webpack_public_path__ + "img/gov-auth.b8ce346f.png";